export default "__VITE_ASSET__eaC1RZJ0__"